/* ==========================================================================
   Reveal on scroll — the news pages' entrance, one engine.

   blocks/blog-index.liquid and blocks/blog-article.liquid both stagger cards
   in, and the rule they run on is the product grid's
   (blocks/product-grid-filters.liquid, setupReveal): stagger by the batch
   that crossed together in reading order, not by a fixed per-index delay, so
   a card scrolled to on its own gets no delay at all and a whole screenful
   ripples top-left to bottom-right.

   Each block asks for this file, so a page carrying both tags fetches once
   and runs twice; the window claim and the per-scope attribute make the
   second run a no-op. assets/epg-rail-auto.js is claimed the same way.

   THE MARKUP WORKS WITHOUT IT. Every start state in
   assets/epg-article-card.css lives inside `prefers-reduced-motion:
   no-preference`, and the fallback below shows everything after a second, so
   a browser with no IntersectionObserver — or a prerender that never runs
   one — is never left looking at a page of invisible cards.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__epgReveal) return;
  window.__epgReveal = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(nodes) {
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].style.setProperty('--d', '0ms');
      nodes[i].classList.add('is-in');
    }
  }

  function bind(scope) {
    if (scope.hasAttribute('data-epg-reveal-bound')) return;
    scope.setAttribute('data-epg-reveal-bound', '');

    var cards = scope.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!cards.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      showAll(cards);
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      var batch = [];
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) batch.push(entries[i]);
      }
      if (!batch.length) return;
      batch.sort(function (a, b) {
        return (a.boundingClientRect.top - b.boundingClientRect.top)
          || (a.boundingClientRect.left - b.boundingClientRect.left);
      });
      batch.forEach(function (entry, index) {
        entry.target.style.setProperty('--d', Math.min(index * 34, 420) + 'ms');
        entry.target.classList.add('is-in');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    for (var j = 0; j < cards.length; j += 1) observer.observe(cards[j]);

    // A card that is never revealed is a story nobody can read. Some webviews
    // and every prerender skip the observer entirely, so show whatever is
    // still hidden after a second rather than trusting it to report back.
    setTimeout(function () {
      var left = scope.querySelectorAll('[data-reveal]:not(.is-in)');
      if (left.length) showAll(left);
    }, 1000);
  }

  function run() {
    var scopes = document.querySelectorAll('[data-epg-reveal-scope]');
    for (var i = 0; i < scopes.length; i += 1) bind(scopes[i]);
  }

  /* The news pager swaps a page of cards in without a navigation, so it needs
     to ask for a fresh pass over markup that did not exist at load. */
  window.__epgRevealScan = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // The theme editor rebuilds a section's markup in place, which leaves the
  // new cards unobserved and permanently invisible.
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
}());
